import { queryOptions } from '@tanstack/react-query'
import { fetchUser } from '@/features/account/services/User/fetchers'
import { UserQuery } from '@/features/account/services/User/constants'

export const userQueryOptions = queryOptions({
  queryKey: [UserQuery] as const,
  queryFn: fetchUser,
  staleTime: Infinity,
})
